import React from 'react';

const convertToSec = (time: number) => time * 60;
const convertToTime = (timeInSeconds: number): string => {
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = timeInSeconds % 60;
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

/**
 * @param start is time in minutes
 * **/
export function useCountDown(start: number) {
  const timeInSec = convertToSec(start);
  const [time, setTime] = React.useState<number>(timeInSec);
  const [isCounting, setIsCounting] = React.useState<boolean>(false);
  const timer = React.useRef<ReturnType<typeof setInterval> | null>(null);
  const remainingTime: string = React.useMemo(
    () => convertToTime(time),
    [time]
  );

  const startTimer = () => {
    if (timer.current) return;
    setIsCounting(true);
    setTime(timeInSec);
    timer.current = setInterval(() => {
      setTime((o) => {
        if (o === 0) {
          clearInterval(timer.current!);
          timer.current = null;
          setIsCounting(false);
          return o;
        }
        return o - 1;
      });
    }, 1000);
  };

  const stopTimer = () => {
    if (timer.current) {
      setIsCounting(false);
      clearInterval(timer.current);
      timer.current = null;
      setTime(start);
    }
    return;
  };

  return {
    counterTime: remainingTime,
    startCountDown: startTimer,
    stopCountDown: stopTimer,
    isCounting,
  };
}
